module.exports = __webpack_public_path__ + "img/beth.a8daba64.jpg";